var _defs, _path, _path2, _ellipse, _ellipse2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse3, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g, _path34, _path35, _path36;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationWomanOnlineMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 196,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "61.181%",
    y1: "36.858%",
    x2: "40.788%",
    y2: "55.524%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78B46A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3500",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "82.186%",
    y1: "28.582%",
    x2: "29.852%",
    y2: "62.428%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78B46A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3500",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "80.66%",
    y1: "21.945%",
    x2: "21.557%",
    y2: "66.572%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78B46A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3500",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "81.016%",
    y1: "60.558%",
    x2: "67.462%",
    y2: "55.262%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC841E",
    offset: "99%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "82.183%",
    y1: "27.602%",
    x2: "29.857%",
    y2: "62.288%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78B46A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F3500",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-195.8%",
    y: "-152.6%",
    width: "491.7%",
    height: "527.4%",
    filterUnits: "objectBoundingBox",
    id: "f"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 25,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.209139076 0 0 0 0 0.0691446444 0 0 0 0 0.478091033 0 0 0 0.497159091 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M0 13.878v26.935L20.984 52.83l23.694-14.013V11.883"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29)",
    fillRule: "nonzero"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.994 178.096L4.676 112.92c-3.512-1.974-6.523-5.209-3.1-7.331L112.286 41.8c1.66-1.03 4.181-1.705 5.873-.72l115.786 67.19c3.512 2.038 4.142 7.717.643 9.774l-105.056 59.95a14.67 14.67 0 01-14.538.102z",
    fill: "#5B36A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.994 175.088L4.676 109.91c-3.512-1.975-6.523-5.21-3.1-7.332l110.71-63.788c1.66-1.029 4.181-1.704 5.873-.72l115.786 67.19c3.512 2.039 4.142 7.717.643 9.775l-105.056 59.949a14.67 14.67 0 01-14.538.103z",
    fill: "#6862E6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.09 89.094l-21.768 12.418s33.533 20.457 40.39 23.338l12.537-18.007",
    fill: "url(#a)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.57 148.67l-21.774-12.393-21.774 12.418s11.34 6.92 22.18 13.274c6.882-4.868 13.771-9.788 21.368-13.3z",
    fill: "url(#b)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.658 72.142L55.847 80.02s1.17 7.222 8.028 10.103l18.082-11.576",
    fill: "url(#c)",
    opacity: 0.46,
    style: {
      mixBlendMode: "multiply"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#68E1FD",
    cx: 76.418,
    cy: 74.155,
    rx: 8.33,
    ry: 5.865
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#974C26",
    cx: 76.412,
    cy: 70.695,
    rx: 6.24,
    ry: 2.553
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.187 66.438c0-1.151-.039-2.303-.129-3.454-.026-.3-.054-.598-.084-.894l-.064-.585c0-.173-.09-.643-.09-.598-.039-.236-.08-.47-.122-.7a27.482 27.482 0 00-4.451-10.888 15.913 15.913 0 00-1.242 6.373c0 .643.051 1.286.103 1.89v.38a25.153 25.153 0 001.158 4.38 21.007 21.007 0 001.344 3.009 41.327 41.327 0 001.846 3.183c.515.81 1.004 1.53 1.5 2.219.154-1.434.224-2.875.23-4.315zm-3.274-12.946a1.035 1.035 0 000-.45c.158.163.315.33.47.502a1.428 1.428 0 00-.477-.052h.007z",
    fill: "#999A1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.329 67.325c.643-.97 1.21-1.93 1.756-2.977.141-.266.279-.532.412-.798l.263-.534.251-.553.277-.643a27.48 27.48 0 002.142-11.575 15.918 15.918 0 00-4.503 4.694 23.024 23.024 0 00-.933 1.647l-.128.237-.033.103c-.122.29-.244.58-.36.875a25.153 25.153 0 00-1.035 3.44 21.005 21.005 0 00-.496 3.261 38.863 38.863 0 00-.167 3.672c0 .958 0 1.833.058 2.675.855-1.138 1.717-2.308 2.496-3.524zm4.245-12.662c.101-.113.176-.247.219-.393.047.223.088.438.122.644-.1-.1-.215-.185-.34-.251z",
    fill: "#999A1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.284 70.193c.647-.321 1.29-.668 1.93-1.041l.482-.296.315-.2.309-.218.36-.264a17.288 17.288 0 004.889-5.55 10.017 10.017 0 00-3.937 1.087c-.354.18-.695.38-1.036.585l-.147.09-.052.045-.476.354c-.593.467-1.152.977-1.672 1.524-.481.498-.922 1.034-1.32 1.601a41.869 41.869 0 00-1.286 1.93c-.308.514-.585.996-.83 1.466.83-.347 1.66-.708 2.47-1.113zm6.38-5.466a.643.643 0 00.245-.141 6.569 6.569 0 01-.154.405.9.9 0 00-.09-.257v-.007zM76.187 66.438c0-1.151-.039-2.303-.129-3.454-.026-.3-.054-.598-.084-.894l-.064-.585c0-.173-.09-.643-.09-.598-.039-.236-.08-.47-.122-.7a27.482 27.482 0 00-4.451-10.888 15.913 15.913 0 00-1.242 6.373c0 .643.051 1.286.103 1.89v.38a25.153 25.153 0 001.158 4.38 21.007 21.007 0 001.344 3.009 41.327 41.327 0 001.846 3.183c.515.81 1.004 1.53 1.5 2.219.154-1.434.224-2.875.23-4.315zm-3.274-12.946a1.035 1.035 0 000-.45c.158.163.315.33.47.502a1.428 1.428 0 00-.477-.052h.007z",
    fill: "#999A1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.329 67.325c.643-.97 1.21-1.93 1.756-2.977.141-.266.279-.532.412-.798l.263-.534.251-.553.277-.643a27.48 27.48 0 002.142-11.575 15.918 15.918 0 00-4.503 4.694 23.024 23.024 0 00-.933 1.647l-.128.237-.033.103c-.122.29-.244.58-.36.875a25.153 25.153 0 00-1.035 3.44 21.005 21.005 0 00-.496 3.261 38.863 38.863 0 00-.167 3.672c0 .958 0 1.833.058 2.675.855-1.138 1.717-2.308 2.496-3.524zm4.245-12.662c.101-.113.176-.247.219-.393.047.223.088.438.122.644-.1-.1-.215-.185-.34-.251z",
    fill: "#999A1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.284 70.193c.647-.321 1.29-.668 1.93-1.041l.482-.296.315-.2.309-.218.36-.264a17.288 17.288 0 004.889-5.55 10.017 10.017 0 00-3.937 1.087c-.354.18-.695.38-1.036.585l-.147.09-.052.045-.476.354c-.593.467-1.152.977-1.672 1.524-.481.498-.922 1.034-1.32 1.601a41.869 41.869 0 00-1.286 1.93c-.308.514-.585.996-.83 1.466.83-.347 1.66-.708 2.47-1.113zm6.38-5.466a.643.643 0 00.245-.141 6.569 6.569 0 01-.154.405.9.9 0 00-.09-.257v-.007z",
    fill: "#999A1C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.735 84.245l-12.048 5.788a2.772 2.772 0 00-.193 4.894l28.554 16.656a2.773 2.773 0 003.731-.894l6.94-10.791",
    fill: "#A1482D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198.264 56.328L102.194.984a4.336 4.336 0 00-6.497 3.756v57.575c0 1.287.686 2.476 1.8 3.12l102.42 59.106a2.323 2.323 0 003.486-2.013V65.19a10.225 10.225 0 00-5.14-8.862z",
    fill: "#F47B56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.2 5.338l93.169 53.588a6.533 6.533 0 013.274 5.66v43.157a2.36 2.36 0 01-3.531 2.045l-95.016-54.482a2.328 2.328 0 01-1.17-2.02V7.235a2.186 2.186 0 013.274-1.897z",
    fill: "#FFF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#AB643C",
    transform: "rotate(-10.9 140.964 84.467)",
    cx: 140.964,
    cy: 84.467,
    rx: 2.026,
    ry: 2.315
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    opacity: 0.32,
    d: "M127.242 63.891l43.297 26.007 21.389-12.431-38.216-22.238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M180.748 58.714l-46.81-28.534a1.621 1.621 0 00-2.431 1.46v16.257a1.704 1.704 0 00.817 1.467l46.803 27.93a1.615 1.615 0 002.412-1.41l.244-15.157a2.276 2.276 0 00-1.035-2.013z",
    fill: "#E2AC00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M169.549 67.08c1.679 2.348 4.631 3.004 6.587 1.473 1.955-1.53 2.18-4.675.501-7.016-1.679-2.34-4.631-3.003-6.587-1.472-1.955 1.53-2.18 4.669-.501 7.016z",
    fill: "#FFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M164.956 55.814l-19.092-11.492a.727.727 0 00-.733 1.247l19.092 11.492a.727.727 0 00.733-1.247zM164.171 60.483l-26.315-15.84a.727.727 0 00-.702 1.248l26.284 15.846a.727.727 0 00.733-1.248v-.006z",
    fill: "#F2F2F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171.408 61.865l-46.784-28.527a1.621 1.621 0 00-2.432 1.46v16.25c-.007.6.3 1.159.81 1.473l46.804 27.93a1.615 1.615 0 002.419-1.44l.244-15.159a2.276 2.276 0 00-1.061-1.987z",
    fill: "#F47B56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M160.209 70.232c1.679 2.347 4.631 3.003 6.587 1.473 1.955-1.53 2.18-4.676.501-7.017-1.679-2.34-4.631-3.003-6.587-1.472-1.955 1.53-2.18 4.669-.501 7.016z",
    fill: "#FFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M155.616 58.965L136.51 47.473a.727.727 0 00-.733 1.248l19.092 11.492a.727.727 0 00.733-1.248h.013zM154.825 63.666l-26.31-15.865a.727.727 0 00-.733 1.248l26.316 15.839a.727.727 0 00.733-1.248l-.006.026z",
    fill: "#F2F2F2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M159.668 63.782l-46.796-28.528a1.621 1.621 0 00-2.432 1.46v16.251a1.704 1.704 0 00.817 1.466l46.803 27.93a1.615 1.615 0 002.419-1.44l.244-15.159c.021-.8-.38-1.551-1.055-1.98z",
    fill: "#68E1FD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M159.668 63.782l-46.796-28.528a1.621 1.621 0 00-2.432 1.46v16.251a1.704 1.704 0 00.817 1.466l46.803 27.93a1.615 1.615 0 002.419-1.44l.244-15.159c.021-.8-.38-1.551-1.055-1.98z",
    fill: "#68E1FD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M148.463 72.148c1.679 2.348 4.631 3.004 6.587 1.473 1.955-1.53 2.18-4.675.501-7.016-1.678-2.34-4.631-3.003-6.586-1.473-1.956 1.53-2.162 4.67-.502 7.016z",
    fill: "#FFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M143.87 60.881L124.772 49.39a.727.727 0 00-.734 1.248l19.092 11.492a.727.727 0 00.734-1.248h.006zM143.079 65.557l-26.316-15.84a.727.727 0 00-.733 1.248l26.315 15.84a.727.727 0 00.734-1.248z",
    fill: "#F2F2F2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M98.25 62.187a22.765 22.765 0 00-6.632 9.717c-2.328 6.43 3.493 16.939 3.493 16.939l9.057-7.17",
    fill: "#FF8F6F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M97.273 147.21l-2.458-1.357.644-3.511s3.66.347 3.981 1.646",
    fill: "#003B94"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M98.173 147.158c.553-.34 1.132-.643 1.705-.945 1.421-.778 3.473-1.582 4.348-3.042a1.697 1.697 0 00-.116-1.929c-1.286-1.556-4.104 1.003-5.544-.72-.283-.341-.419-5.75-.419-5.75l-5.48 1.48s-.926 10.868-.823 11.537c.102.668 1.987 1.286 1.987 1.286a4.857 4.857 0 001.583-.643c.572-.418.051-5.518.784-4.804.734.714 1.055 3.505 1.055 3.505.305.046.614.054.92.025z",
    fill: "#F47B56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M107.738 152.464l-2.457-1.338.643-3.511s3.66.347 3.982 1.646",
    fill: "#003B94"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M108.665 152.412c.553-.34 1.132-.643 1.704-.945 1.422-.778 3.474-1.582 4.349-3.042a1.697 1.697 0 00-.116-1.929c-1.287-1.556-4.104 1.003-5.545-.72-.283-.341-.418-5.75-.418-5.75l-5.48 1.48s-.933 10.906-.83 11.55c.102.643 1.987 1.286 1.987 1.286a4.857 4.857 0 001.583-.643c.572-.418.051-5.518.784-4.804.734.714 1.055 3.505 1.055 3.505.307.042.619.046.927.012z",
    fill: "#F47B56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M89.882 117.133l-1.615 21.588s2.573 3.55 11.2 1.576l.083-14.553M99.846 121.41c-.187 1.858 0 22.36 0 22.36s2.386 4.462 12.775 0l-.148-17.422",
    fill: "#3E2928"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M89.078 124.264c.707.49.952-2.025 1.691-1.594a42.094 42.094 0 008.517 3.755h.064a.586.586 0 01.792.29c1.834.547 3.7.976 5.59 1.286 2.424.386 4.431-1.409 6.92-1.53 0-9.531.046-36.657-4.013-42.445l-12.01-4.038c-.058.99-5.828 7.678-5.686 15.833.16 9.19-1.036 17.858-1.242 20.733-.032.489-.598 7.19-.623 7.71z",
    fill: "#3E2928"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M109.745 73.068l-1.106 10.933s-8.96.36-12.82-2.303v-9.273",
    fill: "#FF8F6F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M121.137 65.872l-.913 1.247A30.002 30.002 0 00121.51 64c.258-.726-.907-1.016-1.164-.289l-.135.373c.112-.386.217-.774.315-1.164a.6.6 0 10-1.164-.29 31.17 31.17 0 01-.907 2.985 21.3 21.3 0 00.425-2.637c.077-.765-1.126-.733-1.197 0-.1 1.01-.28 2.01-.54 2.99a5.57 5.57 0 00-.097-1.029.604.604 0 00-.25-.43 4.653 4.653 0 00-.116-.4.605.605 0 00-1.178.18l-.077 4.502c-.218.467-.501.9-.842 1.287.578.4 1.137.83 1.672 1.286.478.403.933.833 1.364 1.286.386-.48.757-.969 1.113-1.466a.643.643 0 00.115-.129 128.076 128.076 0 013.32-4.682c.476-.527-.573-1.112-1.03-.501z",
    fill: "#FFB5A9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M104.059 63.1s4.233 1.138 5.95 3.859a48.38 48.38 0 012.837 5.845l3.126-4.855s3.795 1.164 5.3 3.029c0 0-4.502 9.84-8.426 10.682-3.924.842-8.092-5.775-8.092-5.775s-.862 2.765-.695-.187",
    fill: "#FF8F6F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M106.748 73.615a8.572 8.572 0 01-2.683-3.82c-.508-1.73.129-3.248.72-4.856a15.643 15.643 0 001.107-4.997c.052-1.684-.141-3.37-.257-5.048a.489.489 0 010-.218c-.566-1.898-1.724-3.505-4.008-3.698-5.911-.502-6.246 6.045-6.2 8.707.044 2.663.328 4.463-1.634 5.576-1.962 1.112-3.378 4.032-1.506 6.392 1.872 2.36.193 1.499-1.055 3.595-1.247 2.097-.926 4.714 1.634 5.66 2.56.945 14.46-.83 15.554-1.93a2.27 2.27 0 00.56-1.608 6.238 6.238 0 00-2.232-3.755z",
    fill: "#007F68"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M112.563 19.62a9.42 9.42 0 011.672 4.888 3.215 3.215 0 01-.547 2.283 1.319 1.319 0 01-1.595.277 2.464 2.464 0 01-.862-.58 3.003 3.003 0 01-.553-.7l-.154-.302c-.042.079-.094.152-.155.218-.153.12-.335.197-.527.225-.322.06-.654.02-.952-.115a3.57 3.57 0 01-1.686-1.512 4.854 4.854 0 01-.746-2.437c-.095-.7.124-1.406.598-1.93a1.377 1.377 0 011.564-.244c.258.103.495.251.7.438.176.149.332.32.464.508l.116.206v-.573l1.286.502.129 3.614c.009.259.089.51.231.727.121.209.306.373.528.47.622.244.909-.292.862-1.609a6.957 6.957 0 00-1.242-3.633 6.091 6.091 0 00-2.85-2.43 2.4 2.4 0 00-2.675.34 3.633 3.633 0 00-1.036 2.971 7.664 7.664 0 001.287 3.859 5.93 5.93 0 002.746 2.572c.408.17.845.255 1.287.25.287.02.575-.033.836-.154l.257-.141.779 1.447-.129.09c-.122.068-.249.129-.38.18-.205.089-.421.15-.643.18a3.217 3.217 0 01-.855 0 4.31 4.31 0 01-1.087-.277 7.076 7.076 0 01-2.573-1.89 11.209 11.209 0 01-1.994-3.113 9.529 9.529 0 01-.824-3.453 5.542 5.542 0 01.592-2.9 3.267 3.267 0 011.827-1.608 3.52 3.52 0 012.534.128 8.175 8.175 0 013.77 3.229zm-2.837 4.573c.211-.27.306-.612.264-.952a2.456 2.456 0 00-.341-1.19 1.634 1.634 0 00-.779-.707.701.701 0 00-.79.103 1.177 1.177 0 00-.284.933c.015.424.141.836.367 1.196.185.326.472.584.817.733.247.127.548.08.746-.116M188.512 89.255a9.388 9.388 0 011.672 4.887 3.215 3.215 0 01-.546 2.283 1.325 1.325 0 01-1.596.277 2.534 2.534 0 01-.862-.58 3.113 3.113 0 01-.553-.7l-.154-.302a1.248 1.248 0 01-.155.218c-.152.12-.334.199-.527.225-.319.064-.65.026-.946-.109a3.57 3.57 0 01-1.685-1.518 4.835 4.835 0 01-.753-2.443c-.099-.7.12-1.408.599-1.93a1.37 1.37 0 011.556-.244c.258.102.496.25.701.437.176.152.331.325.464.515l.122.205v-.572l1.286.495.129 3.614c.011.259.091.51.231.727.121.21.306.374.528.47.643.244.907-.29.868-1.608a6.99 6.99 0 00-1.241-3.64 6.104 6.104 0 00-2.843-2.424 2.406 2.406 0 00-2.676.334 3.633 3.633 0 00-1.01 2.99 7.639 7.639 0 001.286 3.859 5.956 5.956 0 002.78 2.489c.407.17.844.257 1.286.257.287.017.574-.036.836-.155l.257-.141.779 1.447-.13.09c-.121.069-.248.129-.379.18a2.83 2.83 0 01-.643.18 3.281 3.281 0 01-.862 0 4.298 4.298 0 01-1.08-.283 7.076 7.076 0 01-2.573-1.884 11.234 11.234 0 01-1.995-3.12 9.51 9.51 0 01-.823-3.452 5.51 5.51 0 01.592-2.894 3.293 3.293 0 011.827-1.615 3.564 3.564 0 012.54.13 8.188 8.188 0 013.693 3.305zm-2.837 4.572c.213-.269.31-.611.27-.952a2.437 2.437 0 00-.347-1.19 1.608 1.608 0 00-.772-.707.701.701 0 00-.791.097 1.164 1.164 0 00-.29.932c.015.422.142.833.367 1.19.185.328.472.588.817.74a.643.643 0 00.746-.11",
    fill: "#F47B56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.324 116.676L38.55 104.29l-21.768 12.412s12.113 7.562 22.951 13.916c6.883-4.862 13-10.424 20.591-13.942z",
    fill: "url(#e)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 68)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#f)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF9271",
    xlinkHref: "#g"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#DF5C34",
    fillRule: "nonzero",
    d: "M70.984 93.896v26.935l23.694-14.013V79.883z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#F47B56",
    fillRule: "nonzero",
    d: "M50 81.878L74.347 68l20.33 11.883-23.693 14.013z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M71.541 74.182a12.971 12.971 0 017.104 1.565c1.243.731 1.922 1.494 2.018 2.29.096.795-.314 1.487-1.281 2.07a4.557 4.557 0 01-1.493.59c-.434.103-.88.149-1.326.135l-.487-.038c.046.109.076.223.09.34a1.566 1.566 0 01-.256.776c-.254.43-.616.786-1.05 1.032a6.316 6.316 0 01-3.35.885 6.623 6.623 0 01-3.479-.878c-.999-.59-1.511-1.283-1.55-2.078a2.245 2.245 0 011.281-2.007 4.244 4.244 0 011.179-.507 4.588 4.588 0 011.018-.173h.353l-.641-.385 1.8-1.122 4.17 2.456a2.188 2.188 0 002.075 0c.884-.551.568-1.276-.948-2.174a9.63 9.63 0 00-5.278-1.174 10.835 10.835 0 00-5.509 1.584c-1.511.945-2.26 2.072-2.248 3.38 0 1.283.8 2.424 2.357 3.341 1.7.95 3.629 1.41 5.573 1.328a10.463 10.463 0 005.509-1.462 6.177 6.177 0 001.53-1.283c.293-.31.512-.683.641-1.09l.09-.404 2.376.134c.004.073.004.146 0 .219-.043.196-.101.389-.173.577-.103.3-.24.59-.41.859-.244.364-.527.7-.845 1-.42.405-.88.762-1.377 1.065a12.801 12.801 0 01-4.663 1.68 17.588 17.588 0 01-5.439.096 12.448 12.448 0 01-4.67-1.526 6.064 6.064 0 01-2.651-2.783 4.096 4.096 0 010-3.296 6.346 6.346 0 012.633-2.88 14.483 14.483 0 017.327-2.142zm2.332 6.631a1.372 1.372 0 00-.8-1 3.29 3.29 0 00-1.666-.455 2.81 2.81 0 00-1.55.397c-.384.187-.631.573-.64 1 .058.445.345.827.755 1.007a3.27 3.27 0 001.697.43 3.046 3.046 0 001.627-.423c.373-.17.61-.546.603-.956",
    fill: "#3E2928",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationWomanOnlineMobile);
export default __webpack_public_path__ + "static/media/illustration-woman-online-mobile.0ec5a8936cb8f07ad9445292bf50c4ac.svg";
export { ForwardRef as ReactComponent };